module.exports = __webpack_public_path__ + "img/r4.32594b7f.jpg";